<template>
  <div class="w-100 h-100">

    <b-container fluid>
      <h2 class="tw-mb-0 text-aegis-dk">
        Late Product Replacement
      </h2>
    </b-container>
    <hr>
    <b-row>
      <b-col>
        <small>Total: {{ totalRows }} </small>
      </b-col>
      <b-col style="text-align: right; padding-right: 20px;">
        <b-button class="btn bt-sm btn-success" style="font-size: 12px; position: relative; bottom: 10px;" @click="downloadData"><i class="fa fa-download"></i> CSV</b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="tw-overflow-x-scroll">
        <b-table
          id="my-table"
          ref="table"
          striped
          hover
          :items="items"
          :fields="fields"
          :current-page="currentPage"
          :per-page="perPage"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
        >
        </b-table>
      </b-col>
    </b-row>
    <b-row v-if="totalRows > perPage">
      <b-col sm="12" md="12" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          align="fill"
          size="sm"
          class="my-0"
          aria-controls="my-table"
        ></b-pagination>
      </b-col>
    </b-row>
    
  </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";
// import * as _ from "lodash";

export default {
  mixins: [DashboardBaseTemplate],
  data: function() {
    return {
      items: [],
      perPage: 15,
      totalRows: 0,
      currentPage: 1,
      sortBy: 'structure_id',
      sortDesc: false,
      fields: [
        { key: 'structure_id', sortable: true },
        { key: 'cluster', sortable: true },
        { key: 'next_target_date', sortable: true },
        { key: 'placement_period', sortable: true },
        { key: 'products_required', sortable: true },
      ]
    };
  },
  computed: {},
  watch: {},
  created: function() {
     this.getTableData();
  },
  mounted: function() {
  },
  methods: {
    downloadData(){
      let params = {
        return_type: 'csv',
        download: true
      }
      HTTP.get("/kenya/missed_product_placement", {
        params: params
      }).then(response => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement('a');
          fileLink.href = fileURL;
          var filename = 'MissedProductPlacement.csv';
          fileLink.setAttribute('download', filename);
          document.body.appendChild(fileLink);
          fileLink.click();
      });
    },
    getTableData: function(){
      let that = this;
      return HTTP.get("/kenya/missed_product_placement").then(response => {
        that.totalRows = response.data.length;
        that.items = response.data;
      }).catch((error) => {
        HandleErrors.HandleErrors(error);
      });
    }
  }
};
</script>

<style>
</style>